export default "__VITE_ASSET__BgiKX3wK__"